module.exports = __webpack_public_path__ + "img/file-icon_pdf.e3af9ec6.svg";